<!--
 * @Description: 首页
 * @Version: 1.0
 * @Autor: hekai
 * @Date: 2021-07-10 15:05:48
 * @LastEditors: hekai
 * @LastEditTime: 2021-07-10 15:06:24
-->
<template>
  <div>
    <div class="empty" v-if="isEmpty">
      <img src="../../assets/empty.png" alt="">
      <div class="empty-text">暂未发布信息</div>
    </div>
    <template v-else>
      <FrontCover v-if="!isAbnormal"/>
      <CardItem
        v-for="card in cardList"
        :key="card.sort"
        :card="card"
        :certificateStatus="certificateStatus">
      </CardItem>
    </template>

  </div>
</template>

<script>
  import FrontCover from './modules/FrontCover.vue'
  import CardItem from '@views/general/CardItem.vue'
  import { getDetailData, getPreviewData, getDetailDataById, getStaticInformationList } from '@api/user'
  import { isCertificateAbnormal } from '@/enums/CertificateStatusEnums'

  // 解码常见 HTML 实体（数字 / 十六进制 / 常用命名）
  function decodeHtmlEntities(str) {
    if (!str) {
      return ''
    }
    return str
      .replace(/&#x([0-9a-fA-F]+);/g, (_, h) => String.fromCodePoint(parseInt(h, 16)))
      .replace(/&#(\d+);/g, (_, d) => String.fromCodePoint(parseInt(d, 10)))
      .replace(/&nbsp;/g, ' ')
      .replace(/&amp;/g, '&')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'")
  }

  // 从富文本（含 HTML 标签 / 实体 / 字符差异）中提取“产品区块链唯X编号”后的编号
  function extractBlockchainNumber(html) {
    if (!html) {
      return ''
    }
    // 1. 解码 HTML 实体（如 &#66;）
    let text = decodeHtmlEntities(html)
    // 2. 去掉 HTML 标签，避免标签把“编号：”和编号割裂
    text = text.replace(/<[^>]+>/g, '')
    // 3. 兼容写法差异：“唯”与“编号”之间可为“一”(U+4E00)、“─”(U+2500) 等任意 0~3 个字符；
    //    冒号后允许空白 / &nbsp; / 换行 等分隔符
    const m = text.match(/产品区块链唯.{0,3}编号[：:\s ]*([A-Za-z0-9]+)/)
    return m ? m[1] : ''
  }

  export default {
    name: 'Home',
    components: {
      CardItem,
      FrontCover

    },
    data() {
      return {
        productType: 0,
        cardList: [],
        isEmpty: false,
        certificateStatus: ''
      }
    },
    computed: {
      // 是否处于证书异常状态（空值或“正常(0)”均视为正常流程）
      isAbnormal() {
        return isCertificateAbnormal(this.certificateStatus)
      }
    },
    created() {
      this.getPageData()
    },
    methods: {
      parseUrlParams(url) {
        // 解析参数的正则表达式
        let reg = /(\w+)=([^&]+)/g
        let params = {}
        let match

        while (match = reg.exec(url)) {
          let key = match[1]
          let value = decodeURIComponent(match[2])
          if (params[key]) {
            params[key].push(value)
          } else {
            params[key] = [value]
          }
        }
        return params
      },
      getPageData() {
        let params = this.parseUrlParams(window.location.href)
        if (params.preview && params.preview[0] === '1') {
          // 预览接口
          this.initPreview(params)
          return
        }

        let code = params.code ? params.code[0] : null
        // 动态码请求数据
        if (code) {
          getDetailData({ business_key: code }).then((res) => {
            if (!res.success) {
              this.isEmpty = true
              return
            }

            let data = JSON.parse(res.result.businessValue)
            console.log('data', data)
            // data.value是上链的值，如果没有上链，直接用后台数据库的json
            this.loadDataByJson(data.value || JSON.stringify(data))
          })
          return
        }

        let staticCodeId = params.staticCodeId ? params.staticCodeId[0] : null
        if (staticCodeId) {
          // 静态码请求数据
          getDetailDataById({ id: staticCodeId }).then((res) => {
            if (!res.success) {
              this.isEmpty = true
              return
            }

            this.loadDataByJson(res.data.staticJson)
          }).catch(err => {
            console.log(err)
            this.isEmpty = true
          })
          return
        }

        // 默认静态数据展示
        if (!code && !staticCodeId) {
          this.isEmpty = true
        }
      },
      loadDataByJson(json) {
        let _res = JSON.parse(json)
        console.log(_res)
        this.isEmpty = !!_res.isHidden
        // 证书异常状态改为异步获取：从“湾区认证信息”卡片取产品区块链唯一编号，再请求接口
        this.certificateStatus = ''
        if (_res.cardList) {
          this.cardList = _res.cardList.filter(item => item.isShow)
        }
        if (_res.pageTitle) {
          document.title = _res.pageTitle
        }
        this.fetchCertificateStatus()

      },
      // 从“湾区认证信息”卡片中提取“产品区块链唯一编号”
      getBlockchainNumber(card) {
        if (!card) {
          return ''
        }
        // 1. 顶层字段（优先，最可靠）
        if (card.theBlockchainNumberOfTheProduct) {
          return card.theBlockchainNumberOfTheProduct
        }
        // 2. 在 componentList 组件文本（富文本）中查找
        const list = card.componentList || []
        for (const comp of list) {
          if (comp.theBlockchainNumberOfTheProduct) {
            return comp.theBlockchainNumberOfTheProduct
          }
          const text = comp.content || comp.text || ''
          const num = extractBlockchainNumber(text)
          if (num) {
            return num
          }
        }
        return ''
      },
      // 请求接口获取证书异常状态
      fetchCertificateStatus() {
        const card = this.cardList.find(item => item.cardName === '湾区认证信息')
        if (!card) {
          return
        }
        const certificationNumber = this.getBlockchainNumber(card)
        if (!certificationNumber) {
          return
        }
        getStaticInformationList({
          certificationNumber: certificationNumber,
          column: 'createTime',
          order: 'asc',
          pageNo: 1,
          pageSize: 10
        }).then(res => {
          if (res.success && res.result && res.result.records && res.result.records.length) {
            const record = res.result.records[0]
            // certificateExceptionStatus: '0' 表示正常（展示全部界面），1/2/3 为异常状态。
            // 注意 "0" 是 falsy，不能用 || 取值，否则会把正常值当成空。
            const exStatus = record.certificateExceptionStatus
            this.certificateStatus = (exStatus !== undefined && exStatus !== null) ? String(exStatus) : ''
          }
          // 证书异常时，仅展示“湾区认证信息”这一个卡片，其余都不展示
          if (isCertificateAbnormal(this.certificateStatus)) {
            this.cardList = this.cardList.filter(item => item.cardName === '湾区认证信息')
          }
        }).catch(err => {
          console.log(err)
        })
      },
      initPreview(params) {
        let blockChainCode = ''
        if (params.blockChainCode) {
          blockChainCode = params.blockChainCode[0]
        }
        let param = {
          id: blockChainCode
        }
        getPreviewData(param).then((res) => {
          if (!res.success) {
            this.isEmpty = true
            console.log(res)
            return
          }
          this.loadDataByJson(res.result.json)
        }).catch(err => {
          console.log(err)
          this.isEmpty = true
        })
      },
      // 富文本处理
      showHtml(str) {
        return str
          .replace(str ? /&(?!#?\w+;)/g : /&/g, '&amp;')
          .replace(/&lt;/g, '<')
          .replace(/&gt;/g, '>')
          .replace(/&quot;/g, '"')
          .replace(/&#39;/g, "\'")
          .replace(/&amp;nbsp;/g, '\u3000')
      }
    }
  }
</script>

<style lang="less" scoped>
.empty {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #FFFFFF;

  img {
    width: 100%;
    margin-bottom: -20%;
  }

  .empty-text {
    font-size: 28px;
    font-weight: bold;
  }
}
</style>
